import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const FrontPageBannerURL = lazy(() => import('./index'));

/** 路由配置 */
export const routeConfig: RouteProps[] = [
  {
    path: '/my-service',
    element: <FrontPageBannerURL title="我们的服务"/>,
  },
  {
    path: '/function-intro',
    element: <FrontPageBannerURL title="我们的服务"/>,
  }
];
